import { CardGrid } from '../../components/CardGrid';
import { EmptyMessage } from '../../components/EmptyMessage';
import { ItemCard } from '../../components/ItemCard';
import { Section, Title, TitleRow } from '../../components/Section';
import { SkeletonCard } from '../../components/SkeletonCard';
import { cardAspectRatio } from '../../theme/tokens';
import { Subtitle, TitleAlignmentWrapper } from './SpaCategoryListTemplate.styles';
import type { SpaCategoryListTemplateProps } from './SpaCategoryListTemplate.types';

export function SpaCategoryListTemplate({
  categories,
  onSelectCategory,
  isLoading,
  titleLabel = 'Categories',
  subtitleLabel,
  fromPriceLabel = 'From',
  noResultsLabel = 'No categories available.',
  noImageLabel = 'No image',
  columns,
  mobileColumns,
  titleAlignment = 'left',
}: SpaCategoryListTemplateProps) {
  const heading = (
    <TitleAlignmentWrapper $align={titleAlignment}>
      <Title>
        {titleLabel}
        {subtitleLabel && <Subtitle>{subtitleLabel}</Subtitle>}
      </Title>
    </TitleAlignmentWrapper>
  );

  if (isLoading && categories.length === 0) {
    return (
      <Section>
        <TitleRow>{heading}</TitleRow>
        <CardGrid $columns={columns} $mobileColumns={mobileColumns}>
          {Array.from({ length: 6 }).map((_, index) => (
            <SkeletonCard key={index} variant="category" />
          ))}
        </CardGrid>
      </Section>
    );
  }

  if (!isLoading && categories.length === 0) {
    return (
      <Section>
        <TitleRow>{heading}</TitleRow>
        <EmptyMessage>{noResultsLabel}</EmptyMessage>
      </Section>
    );
  }

  return (
    <Section>
      <TitleRow>{heading}</TitleRow>
      <CardGrid $columns={columns} $mobileColumns={mobileColumns}>
        {categories.map((category) => (
          <ItemCard
            key={category.id}
            variant="overlay"
            imageAspectRatio={cardAspectRatio.category.desktop}
            imageMobileAspectRatio={cardAspectRatio.category.mobile}
            image={{ src: category.imageUrl, alt: category.name, placeholderLabel: noImageLabel }}
            title={category.name}
            price={
              category.price
                ? {
                    amount: category.price.amount,
                    currencyCode: category.price.currencyCode,
                    label: fromPriceLabel,
                  }
                : undefined
            }
            ariaLabel={category.name}
            onSelect={() => onSelectCategory(category.id)}
          />
        ))}
      </CardGrid>
    </Section>
  );
}
